/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _TransactionHeadState = {
  id: null,
  total: null,
  note: null
}

class TransactionHeadState extends Record(_TransactionHeadState) {
  mergeModel(model) {
    return this.merge(model)
  }
}

export { TransactionHeadState }
